import styled from 'styled-components';
import {dFlex, dFlexColumn, flexWrap} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, responsive, getSpacing, getFontSize, tokens} from '@tickchak/react-share/app';
import {popUpBody} from '../../../../../../component/newPopup/mobilePopup/MobilePopup.css';

export const categorySection = styled.div`
    ${dFlexColumn}
    ${responsive(getSpacing('spaceLg'), 'gap')};
    width: 100%;
    position: relative;
`;

export const categoryLabel = styled.div`
    ${dFlex};
    gap: ${getSpacing('spaceXs', 'desktop')};
    color: ${getToken('color.text.secondary')};
    ${responsive(getFontSize('caption'), 'font-size')};
`;

export const categoriesWrapper = styled.div`
    ${dFlex}
    ${flexWrap}
    ${responsive(getSpacing('spaceSm'), 'gap')};
    width: 100%;
    padding: ${getSpacing('spaceLg', 'desktop')};
    background: ${tokens.primitives.grays.gray100};
    ${responsive(getSpacing('spaceMd'), 'border-radius')};
`;

export const addCategoryPopupWrapper = styled.div`
    ${popUpBody} {
        min-height: 240px;
        height: 240px;
        max-height: 240px;
    }
`;

